import { useCallback, useId } from 'react';

import { Text } from '~components/Typography';
import {
	InputWithIcons,
	type Props as InputProps,
} from '~shared/ui/molecules/InputWithIcons';

import { Wrapper } from './styles';

export type Props = {
	label?: React.ReactNode;
	error?: string;
	description?: string;
	preventEnter?: boolean;
} & InputProps;

export const InputField = ({
	className,
	label,
	error,
	description,
	preventEnter,
	onKeyDown,
	...rest
}: Props) => {
	const id = useId();

	const handleKeyDown = useCallback(
		(e: React.KeyboardEvent<HTMLInputElement>) => {
			if (preventEnter && e.key === 'Enter') {
				e.preventDefault();
				return;
			}
			onKeyDown?.(e);
		},
		[onKeyDown, preventEnter]
	);

	return (
		<Wrapper className={className}>
			{label && (
				<>
					<label htmlFor={id}>
						<Text size="M" align="left" color="semi-transparent">
							{label}
						</Text>
					</label>
					<div />
				</>
			)}
			<InputWithIcons
				id={id}
				aria-invalid={!!error}
				onKeyDown={handleKeyDown}
				{...rest}
			/>
			{error ? (
				<Text size="M" align="left" color="warn">
					{error}
				</Text>
			) : description ? (
				<Text size="M" align="left" color="semi-transparent">
					{description}
				</Text>
			) : null}
		</Wrapper>
	);
};
